export default __webpack_public_path__ + "static/media/general.7dbb0e93.md";